import { ActionIcon, Text } from "@mantine/core";
import { IconX } from "@tabler/icons-react";
import { formatNZD } from "common/utils";
import React from "react";
import { CreditNoteEntryRowProps } from "types/interface.types";
import { CreditNoteGridRow } from "./DataEntryHeaderDefinitions";
/**
 * Note: This component uses intrinsic controls as oppose to mantine <NumberInput> and <Select> becuase of how
 * expensive it is with rendering. This is especially problematic when we have large sets of product entries
 * to input...
 */
const EntryRowComponent: React.FC<CreditNoteEntryRowProps> = ({
  entry,
  onUpdate,
  onRemove,
}) => {
  return (
    <CreditNoteGridRow>
      <Text fw={600} size="sm">{`${entry.productId}${entry.productCode}`}</Text>
      <Text size="sm">{entry.description}</Text>
      <Text size="sm">{formatNZD(entry.eachPrice)}</Text>
      <Text size="sm">{formatNZD(entry.cartonPrice)}</Text>
      <Text size="sm">{entry.unitsCtn}</Text>
      <Text size="sm">{entry.ordered}</Text>
      <Text size="sm">{entry.supplied}</Text>
      <input
        type="number"
        value={entry.returned}
        onChange={(e) => {
          const val = Number(e.target.value);
          if (!isNaN(val)) onUpdate({ ...entry, returned: val });
        }}
        className="mantine-input"
        style={{ width: "100%", height: 32 }}
      />
      <input
        type="number"
        value={entry.discount}
        onChange={(e) => {
          const val = Number(e.target.value);
          if (!isNaN(val)) onUpdate({ ...entry, discount: val });
        }}
        onBlur={(e) => {
          let val = Number(e.target.value);
          if (val > 100) val = 100;
          if (val >= 1) val = val / 100; // convert to decimal
          val = Number(val.toFixed(3));

          if (val !== entry.discount) {
            onUpdate({ ...entry, discount: val }); // commit to parent
          }
        }}
        className="mantine-input"
        style={{ width: "100%", height: 32, minWidth: 0 }}
      />

      <select
        value={entry.productCode}
        onChange={(e) => onUpdate({ ...entry, productCode: e.target.value })}
        style={{ width: "100%", height: 32 }}
        className="mantine-input"
      >
        <option value="C">Carton</option>
        <option value="E">Each</option>
      </select>
      <ActionIcon onClick={onRemove}>
        <IconX size={18} />
      </ActionIcon>
    </CreditNoteGridRow>
  );
};

// Only re-render if returned or productCode changes
const areEqual = (
  prev: CreditNoteEntryRowProps,
  next: CreditNoteEntryRowProps,
) => JSON.stringify(prev.entry) === JSON.stringify(next.entry);

export const CreditNoteEntryRow = React.memo(EntryRowComponent, areEqual);
